<template>
  <v-form
    ref="form"
    v-model="valid"
    v-if="address != null && address !== undefined"
  >
    <v-container fluid>
      <v-row>
        <v-col xs="12" sm="6" md="4" lg="4">
          <template v-if="readOnly">
            {{ $t("components.addressform.suite_number") }}
            <br />
            <span class="minfo">
              {{ address.SuiteNumber }}
            </span>
          </template>
          <no-autocomplete-textfield
            v-else
            :disabled="disabled === true"
            v-model="address.SuiteNumber"
            :label="$t('components.addressform.suite_number')"
            :rules="[$rules.streetNumber]"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col xs="12" sm="6" md="4" lg="4">
          <template v-if="readOnly">
            {{ $t("components.addressform.street_number") }}
            <br />
            <span class="minfo">
              {{ address.StreetNumber }}
            </span>
          </template>
          <no-autocomplete-textfield
          v-else
            :disabled="disabled === true"
            v-model="address.StreetNumber"
            :label="$t('components.addressform.street_number')"
            :rules="[$rules.streetNumber, $rules.required]"
            :class="isAddressRequired() ? 'required' : ''"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col xs="12" sm="6" md="4" lg="4">
          <template v-if="readOnly">
            {{ $t("components.addressform.street_name") }}
            <br />
            <span class="minfo">
              {{ address.StreetName }}
            </span>
          </template>
          <no-autocomplete-textfield
          v-else
            :disabled="disabled === true"
            v-model="address.StreetName"
            :label="$t('components.addressform.street_name')"
            :rules="[$rules.required]"
            :class="isAddressRequired() ? 'required' : ''"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col xs="12" sm="6" md="4" lg="4">
          <template v-if="readOnly">
            {{ $t("globals.city") }}
            <br />
            <span class="minfo">
              {{ address.City }}
            </span>
          </template>
          <no-autocomplete-textfield
          v-else
            :disabled="disabled === true"
            v-model="address.City"
            :label="$t('globals.city')"
            :rules="[$rules.required]"
            :class="isAddressRequired() ? 'required' : ''"
          ></no-autocomplete-textfield>
        </v-col>
        <v-col xs="12" sm="6" md="4" lg="4">
          <template v-if="readOnly">
            {{ $t("globals.city") }}
            <br />
            <span class="minfo">
              {{ trans(address.Province) }}
            </span>
          </template>
          <trans-select
          v-else
            :disabled="disabled === true"
            :item="address"
            propertyName="Province"
            :items="provinces"
            :label="$t('globals.province')"
            :rules="[$rules.required]"
            :class="isAddressRequired() ? 'required' : ''"
            :clearable="true"
          ></trans-select>
        </v-col>
        <v-col xs="12" sm="6" md="4" lg="4">
          <!-- <no-autocomplete-textfield
            :disabled="disabled === true"
            v-model="address.PostalCode"
            :label="$t('globals.postal_code')"
            :rules="[$rules.required, rules.postalCode]"
            class="required"
            v-mask="postalCodeMask"
          ></no-autocomplete-textfield> -->
          <template v-if="readOnly">
            {{ $t("globals.postal_code") }}
            <br />
            <span class="minfo">
              {{ address.PostalCode }}
            </span>
          </template>
          <no-autocomplete-textfield
          v-else
            :disabled="disabled === true"
            v-model="address.PostalCode"
            :label="$t('globals.postal_code')"
            :rules="[$rules.required, $rules.postalCode]"
            :class="isAddressRequired() ? 'required' : ''"
          ></no-autocomplete-textfield>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TransSelect from "../components/TransSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import { translate } from "../trans";
export default {
  name: "address-form",
  components: {
    TransSelect,
    NoAutocompleteTextfield,
  },
  directives: { mask },
  props: ["item", "provinces", "disabled", "alwaysDirty", "readOnly"],
  data() {
    return {
      postalCodeMask: "A#A #A#",
      dirty: false,
      valid: false,
      address: {},
      rules: {
        postalCode: (v) => {
          let val = this.unmask(v, this.postalCodeMask);
          return !val || this.$rules.postalCode(val);
        },
      },
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
  },
  watch: {
    address: {
      handler(v) {
        console.log("address changed: ", v);
        this.dirty = this.isDirty(v);
        //console.log("address changed: dirty: ", this.dirty);
        if (!this.dirty && !this.alwaysDirty) {
          if (this.$refs.form) this.$refs.form.resetValidation();
        }
        //console.log(this.valid);
        else {
          this.validate();
        }
      },
      deep: true,
      immediate: true,
    },
    item: {
      handler(v) {
        console.log("item changed: ", v);
        this.$refs.form.resetValidation();
        if (this.item.Address) {
          this.address = this.item.Address;
        } else {
          this.address = {};
          this.item.Address = this.address;
        }
        this.dirty = false;
      },
    },
    valid: {
      handler(v) {
        console.log("address form valid: ", v, this.dirty);
        if (this.alwaysDirty) {
          this.$emit("valid", v);
        } else {
          this.$emit("valid", v || !this.dirty);
        }
      },
      immediate: true,
    },
    dirty: {
      handler(v) {
        console.log("address form dirty: ", v, this.dirty);
        if (this.alwaysDirty) {
          this.$emit("valid", v);
        } else {
          this.$emit("valid", v || !this.dirty);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.item.Address) {
      this.address = this.item.Address;
    } else {
      this.address = {};
      this.item.Address = this.address;
    }
    this.$emit("valid", this.valid || !this.dirty);
  },
  methods: {
    trans(item) {
      return translate(item, this.language.language);
    },
    isAddressRequired() {
      for (let key of Object.keys(this.address)) {
        // console.log(key);
        if (
          this.address[key] === undefined ||
          this.address[key] === null ||
          this.address[key] === ""
        ) {
          delete this.address[key];
        }
      }
      // console.log(this.address);
      if (Object.keys(this.address).length === 0) {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
          this.dirty = false;
        }
        // this.$emit("valid", true);
        return false;
      }
      return true;
    },
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    validate() {
      this.dirty = this.isDirty(this.address);
      if (this.dirty) this.$refs.form.validate();
      this.$emit("valid", this.valid);
    },
    isDirty(v) {
      let dirty = false;
      for (let key of Object.keys(v)) {
        if (v[key]) {
          dirty = true;
          //console.log("dirty: ", v[key]);
          break;
        }
      }
      return dirty;
    },
  },
};
</script>

<style></style>
